<template>
    <div class="two-layer-menu-wrapper" :style="style" v-show="show">
        <el-cascader-panel
            class="pop-panel"
            v-model="initValue"
            :options="optionData"
            :props="{ expandTrigger: 'hover', checkStrictly: true, emitPath: false, multiple: multiple }"
        >
            <template slot-scope="{ node, data }">
                <span class="panel-item" @click="clickHandler(data)">{{ data.label }}</span>
            </template>
        </el-cascader-panel>
    </div>
</template>

<script>
/**
 * emit menuChange
 * menus=[{label, value},...], direct=up||down, left=int, topOrBotton=int, isShow=true||false
 */
export default {
    name: "TwoLayerPopup",
    props: ["menus", "direct", "left", "topOrBottom", "isShow", "multiple"],
    data() {
        return {
            style: this.getStyle(),
            show: this.isShow,
            initValue: []
        };
    },
    watch: {
        isShow(newVal) {
            this.show = newVal;
            this.showChild = false;
            if (!newVal) {
                // 多选的时候关闭展示之前把选中的传递出去
                this.initValue.length > 0 && this.$emit("multipleChange", this.initValue);
                this.initValue = [];
            }
        }
    },
    computed: {
        optionData() {
            return this.deleteMenuChildren(this.menus);
        }
    },
    methods: {
        deleteMenuChildren(data, value = 1) {
            data.forEach(item => {
                item.level = value;
                item.children && item.children.length ? this.deleteMenuChildren(item.children, value + 1) : delete item.children;
            });
            return data;
        },
        getStyle() {
            let style = {
                left: (this.left || 0) + "px"
            };
            style[this.direct == "up" ? "bottom" : "top"] = (this.topOrBottom || 30) + "px";

            return style;
        },
        clickHandler(data) {
            !this.multiple && (this.initValue = [data.value]);
            // emit返回节点对象{label, value, level}
            this.$emit("menuChange", data);
        }
    }
};
</script>

<style lang="less" scoped>
.two-layer-menu-wrapper {
    position: absolute;
    background: #fff;
    border-radius: 4px;
    z-index: 1;
    box-shadow: 0 0 8px 0 rgba(90, 98, 111, 0.25);
    .pop-panel {
        /deep/.el-cascader-menu {
            min-width: 150px;
            width: 150px;
        }
        /deep/.el-cascader-node {
            padding: 0 12px 0 12px;
        }
        /deep/.el-cascader-menu {
            .el-radio {
                display: none;
            }
            .el-cascader-node__label {
                padding: 0;
            }
        }
        /deep/.el-cascader-menu__list {
            padding: 0;
        }
        .panel-item {
            display: inline-block;
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            vertical-align: top;
        }
    }
}
</style>
